import { Cog } from 'lucide-react';
import { StubPage } from './StubPage';

export function GeneralPage() {
  return (
    <StubPage
      icon={Cog}
      title="General"
      description="App-wide preferences and defaults."
    />
  );
}
